import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { IAccountDisabledService } from '@platform-frontend/account';
import { CloseWindow, Navigate } from '@platform-frontend/util';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccountDisabledService implements IAccountDisabledService {
  constructor(private store: Store) {}

  getRouteParent(): string {
    return '/account-disabled';
  }

  gotoDeactivatedAccountRoutes(): boolean {
    return true;
  }

  finishAccountReactivationWithoutRedirection(): Observable<unknown> {
    return this.store.dispatch(new Navigate(['/account-disabled/welcome-back']));
  }

  finishTermsDeclineWithoutRedirection(): Observable<unknown> {
    return this.store.dispatch(new Navigate(['/account-disabled/deactivated-account']));
  }

  finishTermsAcceptanceWithoutRedirection(): Observable<unknown> {
    return this.store.dispatch(new CloseWindow());
  }

  showCancelButtonsOnDeactivatedAccount(): boolean {
    return true;
  }
}
